import { Typography } from '@mui/material';

type UserProfileDatesTemplateProps = {
  label: string;
  value?: string;
  valueTestId?: string;
};

export const UserProfileDatesTemplate = ({ label, value, valueTestId }: UserProfileDatesTemplateProps) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <Typography
                noWrap
                variant="caption"
                color="textSecondary"
            >
                {label}
            </Typography>
            <Typography data-testid={valueTestId} variant="body2">{value}</Typography>
        </div>
    );
};
